
        <span class="input-group">
          <input type="text" maxlength="4"  class="form-control" (keyup)="onChange()"  [(ngModel)]="numberCount" />
          <!-- <span class="input-group-addon btn btn-warning" [ngClass]= "!isNum?'dis':''" (click)="valueChanged()" >Add</span> -->
        </span>